import React from 'react'
import { Icon, Slider } from '../../../atoms'
import PlatinumRichText from '../mark-down'

interface ICard {
  iconPlacement: string
  icon: string
  title: string
  bodyText: string
}

export interface ICardCarouselJsonBody {
  cards: ICard[]
  title: string
  showSubHeader?: boolean
  subHeaderContent?: string
}
export interface ICardCarouselProps {
  jsonBody: ICardCarouselJsonBody
  name: string
  rawName: string
  sys: {
    id: string
  }
  variant: string
  showHeader: boolean
}

const CardCarousel: React.FC<ICardCarouselProps> = ({
  jsonBody,
  name,
  rawName,
  sys,
  variant,
  showHeader,
}: ICardCarouselProps): React.ReactElement<ICardCarouselProps> => {
  const { cards, title } = jsonBody

  let classCard = 'CardCarousel__Card tCards'
  if (cards.length > 3) {
    classCard = 'CardCarousel__Card fCards'
  }

  try {
    return (
      <div id={name}>
        <section className='CardCarousel' data-controller='platinum-carousel'>
          {showHeader && title && <h2 className='CardCarousel__title'>{title}</h2>}
          {jsonBody.showSubHeader && (
            <div className='CardCarousel__subHeader'>{jsonBody.subHeaderContent}</div>
          )}
          <div className='CardCarousel__Container'>
            {cards.length > 3 && (
              <div
                id='CardCarousel__leftArrow'
                className='CardCarousel__leftArrow'
                data-platinum-carousel-target='leftArrowIcon'
                data-action='click->platinum-carousel#leftArrowIconClick'
              >
                <Icon glyph={'ButtonLeftDisabled'} size={24} desktopSize={40} />
              </div>
            )}
            <div
              className='CardCarousel__Cards'
              data-platinum-carousel-target='carouselContainer'
              data-action='scroll->platinum-carousel#handleScroll'
            >
              {cards.map((card, index) => {
                return (
                  <div
                    key={index}
                    className={`${classCard}`}
                    data-platinum-carousel-target='carouselCard'
                    /* eslint-disable camelcase */
                    data-scroll-tracking={JSON.stringify({
                      component_category: 'platinum-component',
                      component_id: sys?.id,
                      component_name: 'cardCarousel',
                      contentful_name: rawName,
                      contentful_variant: variant,
                      additionalProps: { title: card.title },
                    })}
                  >
                    {card.iconPlacement === 'title' && (
                      <div className='CardCarousel__Card--titleIcon'>
                        <Icon glyph={card.icon} size={32} desktopSize={40} color='#34454E' />
                      </div>
                    )}
                    <div className='CardCarousel__Card__header'>
                      <div
                        className={
                          card.iconPlacement === 'inline'
                            ? 'CardCarousel__Card__header--inlineIcon'
                            : 'CardCarousel__Card__header--hideInlineIcon'
                        }
                      >
                        <Icon glyph={card.icon} size={32} color='#34454E' />
                      </div>

                      <h3 className='CardCarousel__Card__header--title'>{card.title}</h3>
                    </div>
                    <div className='CardCarousel__Card__body'>
                      {PlatinumRichText(card.bodyText, 'CarouselRichText')}
                    </div>
                  </div>
                )
              })}
            </div>
            {cards.length > 3 && (
              <div
                id='CardCarousel__rightArrow'
                className='CardCarousel__rightArrow'
                data-platinum-carousel-target='rightArrowIcon'
                data-action='click->platinum-carousel#rightArrowIconClick'
              >
                <Icon glyph={'arrow-right'} size={24} desktopSize={40} />
              </div>
            )}
          </div>
          <div className='CardCarousel__nav'>
            <Slider cards={cards} variant={'primary'} />
          </div>
        </section>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default CardCarousel
